module.exports = __webpack_public_path__ + "static2023-4-17/img/empty.9605a676.png";